import { OMSEventType } from "@redotech/redo-model/fulfillments/fulfillment-group-events";
import { OMSMetricsResponseSchema } from "@redotech/redo-model/fulfillments/metrics";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getEventTypeCount = {
  name: "getEventTypeCount" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    eventTypes: z.array(createEnum(OMSEventType)),
  }),
  output: OMSMetricsResponseSchema,
};
